import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_AUDITS](state, data) {
    state.allAudits = data
  },
}
